import { useMemo } from 'react';

import {
  GetStaticPageRoutesQuery,
  IGetStaticPageRoutesQuery,
  IStaticPageRoute
} from 'remote/queries/static-page';
import { useSanityQuery } from 'state/graphql';

export const useStaticPageRoutes = () => {
  const { data, error, loading, refetch } = useSanityQuery<IGetStaticPageRoutesQuery>(
    GetStaticPageRoutesQuery
  );

  const routes = useMemo<IStaticPageRoute[]>(
    () => (data && data.allStaticPages ? data.allStaticPages : []),
    [data]
  );

  return { error, loading, refetch, routes };
};
